import { Component, inject, DOCUMENT } from '@angular/core';

import { MatTab, MatTabGroup } from '@angular/material/tabs';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-sidebar-notice',
  templateUrl: './sidebar-notice.component.html',
  styleUrls: ['./sidebar-notice.component.scss'],
  imports: [MatTabGroup, MatTab, MatButton, MatIcon],
})
export class SidebarNoticeComponent {
  private document = inject<Document>(DOCUMENT);

  test = true;

  click(): void {
    this.test = !this.test;
    console.log('dummy');

    const htmlElement = this.document.querySelector('html')!;
    if (this.test) {
      htmlElement.classList.add('theme-dark');
    } else {
      htmlElement.classList.remove('theme-dark');
    }
    window.location.reload();

    return;
  }
}
